<div class="container small-text mb-4">
	<div class="row">
		<div class="col-md-3 p-1 fw-bold">Wszystkie zarezerwowane</div>
		<div class="col-md-2 p-1 fw-bold">Wolne pokoje</div>
		<div class="col-md-2 p-1 fw-bold">Potwierdzone</div>
		<div class="col-md-1 p-1 fw-bold">Opcje</div>
	</div>
	<div class="row">
		<hr class="custom-line" />
	</div>
	<div class="row">
		<div class="col-md-3 p-1">{{ sumOfAllReservations() }}</div>
		<div class="col-md-2 p-1">{{ sumOfAllRemainingRooms() }}</div>
		<div class="col-md-2 p-1">{{ sumOfConfirmedOffers() }}</div>
		<div class="col-md-1 p-1">{{ sumOfOptionOffers() }}</div>
	</div>
</div>
